import { Download01, Edit05 } from "@untitledui/icons";
import { Dropdown } from "@/components/base/dropdown/dropdown";
import { useDownloadInfractionAttachment } from "../hooks/use-download-infraction-attachment";
import type { InfractionListItem } from "../types/infraction.types";
import { canEditInfractionFromListItem } from "../utils/infraction-row-actions";

type InfractionRowActionsMenuProps = {
	item: InfractionListItem;
	onEdit: (id: string) => void;
	onGenerateGuide: (id: string) => void;
};

export function InfractionRowActionsMenu({
	item,
	onEdit,
	onGenerateGuide,
}: InfractionRowActionsMenuProps) {
	const { mutate: downloadAttachment, isPending: isDownloading } =
		useDownloadInfractionAttachment();

	const rowId = String(item.id);
	const canEdit = canEditInfractionFromListItem(item);
	// const canGenerateGuide = canGeneratePaymentGuideFromListItem(item);

	return (
		<Dropdown.Root>
			<Dropdown.DotsButton aria-label="Ações da infração" />
			<Dropdown.Popover>
				<Dropdown.Menu>
					{/* {canGenerateGuide ? (
						<Dropdown.Item
							icon={File06}
							label="Gerar guia de pagamento"
							onAction={() => {
								onGenerateGuide(rowId);
							}}
						/>
					) : null} */}
					{item.hasAttachment ? (
						<Dropdown.Item
							icon={Download01}
							isDisabled={isDownloading}
							label={isDownloading ? "Baixando..." : "Baixar arquivo"}
							onAction={() => {
								downloadAttachment(rowId);
							}}
						/>
					) : null}
					{canEdit ? (
						<Dropdown.Item
							icon={Edit05}
							label="Editar Infração"
							onAction={() => {
								onEdit(rowId);
							}}
						/>
					) : null}
				</Dropdown.Menu>
			</Dropdown.Popover>
		</Dropdown.Root>
	);
}
